export default __webpack_public_path__ + "static/media/nextActive.0b8b646d.svg";